import { loginRequest } from '../authConfig';
import { msalInstance } from '../index';

import { ROLE } from "../shared/constants";
import { UserModel } from "../shared/types";

export const getAccessToken = async () => {
    const account = msalInstance.getAllAccounts()[0];
    const accessTokenRequest = {
        ...loginRequest,
        account
    };

    try {
        return (await msalInstance.acquireTokenSilent(accessTokenRequest)).accessToken;
    } catch (error) {
        try {
            return (await msalInstance.acquireTokenRedirect(accessTokenRequest));
        } catch (error) {
            console.log({ error });
            throw new Error(`No access token: ${error}`);
        }
    }
}

export const hasCMSAccess = (user: UserModel) => {
    return user.role === ROLE.admin;
}